import React, { useEffect, useState } from 'react';
import {
  collection, getDocs, addDoc, updateDoc, deleteDoc,
  doc, serverTimestamp, query, where
} from 'firebase/firestore';
import { db } from './firebase';
import { useAuth } from './AuthContext';

// ── PESTAÑA PRODUCTOS (solo admin) ───────────────────────────
// Gestiona la lista de productos y aromas disponibles en el sistema
function Productos() {
  const [productos, setProductos] = useState([]);
  const [aromas, setAromas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('productos'); // 'productos' | 'aromas'

  // Modal producto
  const [showProdModal, setShowProdModal] = useState(false);
  const [editProd, setEditProd] = useState(null);
  const [prodForm, setProdForm] = useState({ nombre: '', descripcion: '' });

  // Modal aroma
  const [showAromaModal, setShowAromaModal] = useState(false);
  const [editAroma, setEditAroma] = useState(null);
  const [aromaForm, setAromaForm] = useState({ nombre: '' });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function load() {
    setLoading(true);
    try {
      const [prodSnap, aromaSnap] = await Promise.all([
        getDocs(collection(db, 'productos')),
        getDocs(collection(db, 'aromas')),
      ]);
      const prods = [];
      prodSnap.forEach(d => prods.push({ id: d.id, ...d.data() }));
      prods.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setProductos(prods);

      const ars = [];
      aromaSnap.forEach(d => ars.push({ id: d.id, ...d.data() }));
      ars.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setAromas(ars);
    } catch (err) { console.error(err); }
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  // ── PRODUCTOS CRUD ──
  function openNewProd() { setEditProd(null); setProdForm({ nombre: '', descripcion: '' }); setError(''); setShowProdModal(true); }
  function openEditProd(p) { setEditProd(p); setProdForm({ nombre: p.nombre, descripcion: p.descripcion || '' }); setError(''); setShowProdModal(true); }

  async function handleSaveProd(e) {
    e.preventDefault(); setError(''); setSaving(true);
    try {
      if (!prodForm.nombre.trim()) { setError('El nombre es requerido.'); setSaving(false); return; }
      const existe = productos.find(p => p.nombre.toLowerCase() === prodForm.nombre.toLowerCase() && p.id !== editProd?.id);
      if (existe) { setError('Ya existe un producto con ese nombre.'); setSaving(false); return; }
      const data = { nombre: prodForm.nombre.trim(), descripcion: prodForm.descripcion.trim(), updatedAt: serverTimestamp() };
      if (editProd) {
        await updateDoc(doc(db, 'productos', editProd.id), data);
      } else {
        await addDoc(collection(db, 'productos'), { ...data, createdAt: serverTimestamp() });
      }
      await load(); setShowProdModal(false);
    } catch (err) { setError(err.message); }
    setSaving(false);
  }

  async function handleDeleteProd(p) {
    if (!window.confirm(`¿Eliminar el producto "${p.nombre}"?\nEsto no elimina el stock ya asignado.`)) return;
    await deleteDoc(doc(db, 'productos', p.id));
    await load();
  }

  // ── AROMAS CRUD ──
  function openNewAroma() { setEditAroma(null); setAromaForm({ nombre: '' }); setError(''); setShowAromaModal(true); }
  function openEditAroma(a) { setEditAroma(a); setAromaForm({ nombre: a.nombre }); setError(''); setShowAromaModal(true); }

  async function handleSaveAroma(e) {
    e.preventDefault(); setError(''); setSaving(true);
    try {
      if (!aromaForm.nombre.trim()) { setError('El nombre es requerido.'); setSaving(false); return; }
      const existe = aromas.find(a => a.nombre.toLowerCase() === aromaForm.nombre.toLowerCase() && a.id !== editAroma?.id);
      if (existe) { setError('Ya existe ese aroma.'); setSaving(false); return; }
      const data = { nombre: aromaForm.nombre.trim(), updatedAt: serverTimestamp() };
      if (editAroma) {
        await updateDoc(doc(db, 'aromas', editAroma.id), data);
      } else {
        await addDoc(collection(db, 'aromas'), { ...data, createdAt: serverTimestamp() });
      }
      await load(); setShowAromaModal(false);
    } catch (err) { setError(err.message); }
    setSaving(false);
  }

  async function handleDeleteAroma(a) {
    if (!window.confirm(`¿Eliminar el aroma "${a.nombre}"?\nEsto no elimina el stock ya asignado.`)) return;
    await deleteDoc(doc(db, 'aromas', a.id));
    await load();
  }

  if (loading) return <div className="spinner" />;

  return (
    <div>
      {/* Sub-tabs productos / aromas */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button
          className={`btn ${tab === 'productos' ? 'btn-primary' : 'btn-ghost'}`}
          style={{ fontSize: 12 }}
          onClick={() => setTab('productos')}
        >
          Productos ({productos.length})
        </button>
        <button
          className={`btn ${tab === 'aromas' ? 'btn-primary' : 'btn-ghost'}`}
          style={{ fontSize: 12 }}
          onClick={() => setTab('aromas')}
        >
          Aromas ({aromas.length})
        </button>
      </div>

      {/* ── LISTA PRODUCTOS ── */}
      {tab === 'productos' && (
        <div>
          <div className="toolbar">
            <p style={{ fontSize: 13, color: 'var(--text-light)' }}>
              Estos productos aparecen al cargar el catálogo.
            </p>
            <button className="btn btn-primary" onClick={openNewProd}>+ Nuevo producto</button>
          </div>
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr><th>Nombre</th><th>Descripción</th><th>Acciones</th></tr>
                </thead>
                <tbody>
                  {productos.length === 0 ? (
                    <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--text-light)', padding: 40 }}>
                      Sin productos cargados. Agregá el primero.
                    </td></tr>
                  ) : productos.map(p => (
                    <tr key={p.id}>
                      <td style={{ fontWeight: 600 }}>{p.nombre}</td>
                      <td style={{ color: 'var(--text-light)' }}>{p.descripcion || '—'}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-ghost btn-sm" onClick={() => openEditProd(p)}>Editar</button>
                          <button className="btn btn-danger btn-sm" onClick={() => handleDeleteProd(p)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ── LISTA AROMAS ── */}
      {tab === 'aromas' && (
        <div>
          <div className="toolbar">
            <p style={{ fontSize: 13, color: 'var(--text-light)' }}>
              Estos aromas aparecen al cargar el catálogo.
            </p>
            <button className="btn btn-primary" onClick={openNewAroma}>+ Nuevo aroma</button>
          </div>
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr><th>Nombre</th><th>Acciones</th></tr>
                </thead>
                <tbody>
                  {aromas.length === 0 ? (
                    <tr><td colSpan={2} style={{ textAlign: 'center', color: 'var(--text-light)', padding: 40 }}>
                      Sin aromas cargados. Agregá el primero.
                    </td></tr>
                  ) : aromas.map(a => (
                    <tr key={a.id}>
                      <td style={{ fontWeight: 500 }}>{a.nombre}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-ghost btn-sm" onClick={() => openEditAroma(a)}>Editar</button>
                          <button className="btn btn-danger btn-sm" onClick={() => handleDeleteAroma(a)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Modal producto */}
      {showProdModal && (
        <div className="modal-overlay" onClick={() => setShowProdModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">{editProd ? 'Editar producto' : 'Nuevo producto'}</div>
              <button className="modal-close" onClick={() => setShowProdModal(false)}>✕</button>
            </div>
            {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
            <form className="modal-form" onSubmit={handleSaveProd}>
              <div className="field-group">
                <label>Nombre del producto</label>
                <input
                  value={prodForm.nombre}
                  onChange={e => setProdForm(f => ({ ...f, nombre: e.target.value }))}
                  required placeholder="Ej: Difusor Petaca"
                />
              </div>
              <div className="field-group">
                <label>Descripción (opcional)</label>
                <textarea
                  rows={2}
                  value={prodForm.descripcion}
                  onChange={e => setProdForm(f => ({ ...f, descripcion: e.target.value }))}
                  placeholder="Ej: Difusor de varillas 200ml"
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-ghost" onClick={() => setShowProdModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal aroma */}
      {showAromaModal && (
        <div className="modal-overlay" onClick={() => setShowAromaModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">{editAroma ? 'Editar aroma' : 'Nuevo aroma'}</div>
              <button className="modal-close" onClick={() => setShowAromaModal(false)}>✕</button>
            </div>
            {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
            <form className="modal-form" onSubmit={handleSaveAroma}>
              <div className="field-group">
                <label>Nombre del aroma</label>
                <input
                  value={aromaForm.nombre}
                  onChange={e => setAromaForm(f => ({ ...f, nombre: e.target.value }))}
                  required placeholder="Ej: Vainilla y coco"
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-ghost" onClick={() => setShowAromaModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// ── PESTAÑA CATÁLOGO (solo admin) ─────────────────────────────
function Catalogo() {
  const [catalogo, setCatalogo] = useState([]);
  const [productos, setProductos] = useState([]);
  const [aromas, setAromas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const emptyForm = { producto: '', aroma: '', precio: '', costo: '' };
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  async function load() {
    setLoading(true);
    try {
      const [catSnap, prodSnap, aromaSnap] = await Promise.all([
        getDocs(collection(db, 'catalogo')),
        getDocs(collection(db, 'productos')),
        getDocs(collection(db, 'aromas')),
      ]);
      const cat = [];
      catSnap.forEach(d => cat.push({ id: d.id, ...d.data() }));
      cat.sort((a, b) => a.producto.localeCompare(b.producto));
      setCatalogo(cat);

      const prods = [];
      prodSnap.forEach(d => prods.push({ id: d.id, ...d.data() }));
      prods.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setProductos(prods);

      const ars = [];
      aromaSnap.forEach(d => ars.push({ id: d.id, ...d.data() }));
      ars.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setAromas(ars);
    } catch (err) { console.error(err); }
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  function openNew() { setEditItem(null); setForm(emptyForm); setError(''); setShowModal(true); }
  function openEdit(item) {
    setEditItem(item);
    setForm({ producto: item.producto, aroma: item.aroma, precio: item.precio, costo: item.costo || '' });
    setError(''); setShowModal(true);
  }

  async function handleSave(e) {
    e.preventDefault(); setError(''); setSaving(true);
    try {
      const data = {
        producto: form.producto, aroma: form.aroma,
        precio: Number(form.precio), costo: Number(form.costo) || 0,
        updatedAt: serverTimestamp()
      };
      if (editItem) {
        await updateDoc(doc(db, 'catalogo', editItem.id), data);
      } else {
        const existe = catalogo.find(c => c.producto === form.producto && c.aroma === form.aroma);
        if (existe) { setError('Ese producto y aroma ya existe en el catálogo.'); setSaving(false); return; }
        await addDoc(collection(db, 'catalogo'), { ...data, createdAt: serverTimestamp() });
      }
      await load(); setShowModal(false);
    } catch (err) { setError(err.message); }
    setSaving(false);
  }

  async function handleDelete(item) {
    if (!window.confirm(`¿Eliminar "${item.producto} · ${item.aroma}" del catálogo?`)) return;
    await deleteDoc(doc(db, 'catalogo', item.id));
    await load();
  }

  const filtered = catalogo.filter(c =>
    !search || `${c.producto} ${c.aroma}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {productos.length === 0 && (
        <div className="alert-item alert-warning" style={{ marginBottom: 16 }}>
          ⚠️ No hay productos cargados. Primero cargalos en la pestaña <strong>Productos</strong>.
        </div>
      )}
      <div className="toolbar">
        <input className="search-input" placeholder="Buscar..." value={search} onChange={e => setSearch(e.target.value)} />
        <button className="btn btn-primary" onClick={openNew} disabled={productos.length === 0}>
          + Agregar al catálogo
        </button>
      </div>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-wrap">
          {loading ? <div className="spinner" /> : (
            <table>
              <thead>
                <tr>
                  <th>Producto</th><th>Aroma</th><th>Costo</th>
                  <th>Precio venta</th><th>Comisión 20%</th><th>Para Floreciendo</th><th>Margen</th><th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={8} style={{ textAlign: 'center', color: 'var(--text-light)', padding: 40 }}>
                    Sin productos en el catálogo.
                  </td></tr>
                ) : filtered.map(item => {
                  const comision = item.precio * 0.2;
                  const paraFlor = item.precio * 0.8;
                  const margen = item.costo ? ((paraFlor - item.costo) / item.costo * 100) : null;
                  return (
                    <tr key={item.id}>
                      <td style={{ fontWeight: 500 }}>{item.producto}</td>
                      <td style={{ color: 'var(--text-light)' }}>{item.aroma}</td>
                      <td style={{ color: 'var(--text-light)' }}>
                        {item.costo ? `$${Number(item.costo).toLocaleString('es-AR', { maximumFractionDigits: 0 })}` : '—'}
                      </td>
                      <td style={{ fontWeight: 700, color: 'var(--forest)' }}>
                        ${Number(item.precio).toLocaleString('es-AR', { maximumFractionDigits: 0 })}
                      </td>
                      <td style={{ color: 'var(--terracota)' }}>
                        ${comision.toLocaleString('es-AR', { maximumFractionDigits: 0 })}
                      </td>
                      <td>${paraFlor.toLocaleString('es-AR', { maximumFractionDigits: 0 })}</td>
                      <td>{margen !== null
                        ? <span className={`badge ${margen > 0 ? 'badge-green' : 'badge-red'}`}>{margen.toFixed(0)}%</span>
                        : '—'}
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-ghost btn-sm" onClick={() => openEdit(item)}>Editar</button>
                          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">{editItem ? 'Editar precio' : 'Agregar al catálogo'}</div>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
            <form className="modal-form" onSubmit={handleSave}>
              <div className="field-group">
                <label>Producto</label>
                <select value={form.producto} onChange={e => setForm(f => ({ ...f, producto: e.target.value }))} required disabled={!!editItem}>
                  <option value="">Seleccionar...</option>
                  {productos.map(p => <option key={p.id} value={p.nombre}>{p.nombre}</option>)}
                </select>
              </div>
              <div className="field-group">
                <label>Aroma</label>
                <select value={form.aroma} onChange={e => setForm(f => ({ ...f, aroma: e.target.value }))} required disabled={!!editItem}>
                  <option value="">Seleccionar...</option>
                  {aromas.map(a => <option key={a.id} value={a.nombre}>{a.nombre}</option>)}
                </select>
              </div>
              <div className="grid-2">
                <div className="field-group">
                  <label>Costo $</label>
                  <input type="number" min="0" value={form.costo} onChange={e => setForm(f => ({ ...f, costo: e.target.value }))} placeholder="Opcional" />
                </div>
                <div className="field-group">
                  <label>Precio de venta $</label>
                  <input type="number" min="0" value={form.precio} onChange={e => setForm(f => ({ ...f, precio: e.target.value }))} required />
                </div>
              </div>
              {form.precio && (
                <div className="info-pill">
                  Comisión (20%): <strong>${(Number(form.precio) * 0.2).toLocaleString('es-AR', { maximumFractionDigits: 0 })}</strong>
                  &nbsp;· Para Floreciendo: <strong>${(Number(form.precio) * 0.8).toLocaleString('es-AR', { maximumFractionDigits: 0 })}</strong>
                  {form.costo && <span>&nbsp;· Margen: <strong>{(((Number(form.precio) * 0.8) - Number(form.costo)) / Number(form.costo) * 100).toFixed(0)}%</strong></span>}
                </div>
              )}
              <div className="modal-actions">
                <button type="button" className="btn btn-ghost" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// ── PESTAÑA STOCK POR EMBAJADORA ─────────────────────────────
function StockEmbajadoras({ userData, isAdmin }) {
  const [items, setItems] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [embajadoras, setEmbajadoras] = useState([]);
  const [filterEmbajadora, setFilterEmbajadora] = useState('all');
  const [filterAlerta, setFilterAlerta] = useState('all');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showIngresoModal, setShowIngresoModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const emptyForm = { catalogoId: '', embajadoraId: '', cantidad: 1, stockMinimo: 1 };
  const [form, setForm] = useState(emptyForm);
  const [ingresoForm, setIngresoForm] = useState({ cantidad: 1, observacion: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { if (userData) load(); }, [userData]);

  async function load() {
    if (!userData?.uid) return;
    setLoading(true);
    try {
      const catSnap = await getDocs(collection(db, 'catalogo'));
      const cat = [];
      catSnap.forEach(d => cat.push({ id: d.id, ...d.data() }));
      cat.sort((a, b) => a.producto.localeCompare(b.producto));
      setCatalogo(cat);

      const usersSnap = await getDocs(query(collection(db, 'users'), where('approved', '==', true)));
      const embs = [];
      usersSnap.forEach(d => embs.push({ id: d.id, ...d.data() }));
      setEmbajadoras(embs);

      const q = isAdmin
        ? collection(db, 'stock')
        : query(collection(db, 'stock'), where('embajadoraId', '==', userData.uid));
      const snap = await getDocs(q);
      const rows = [];
      snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
      rows.sort((a, b) => a.producto.localeCompare(b.producto));
      setItems(rows);
    } catch (err) { console.error(err); }
    setLoading(false);
  }

  const stockTotal = {};
  items.forEach(i => {
    const key = `${i.producto}||${i.aroma}`;
    if (!stockTotal[key]) stockTotal[key] = { producto: i.producto, aroma: i.aroma, total: 0 };
    stockTotal[key].total += i.stockDisponible || 0;
  });

  const filtered = items.filter(i => {
    if (filterEmbajadora !== 'all' && i.embajadoraId !== filterEmbajadora) return false;
    if (filterAlerta === 'urgente' && i.stockDisponible !== 0) return false;
    if (filterAlerta === 'bajo' && !(i.stockDisponible > 0 && i.stockDisponible <= i.stockMinimo)) return false;
    if (filterAlerta === 'ok' && !(i.stockDisponible > i.stockMinimo)) return false;
    if (search && !`${i.producto} ${i.aroma} ${i.embajadoraNombre || ''}`.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const selectedCat = catalogo.find(c => c.id === form.catalogoId);

  async function handleAddStock(e) {
    e.preventDefault();
    if (!isAdmin) return;
    setError(''); setSaving(true);
    try {
      const emb = embajadoras.find(x => x.id === form.embajadoraId);
      if (!emb) { setError('Seleccioná una embajadora.'); setSaving(false); return; }
      if (!selectedCat) { setError('Seleccioná un producto.'); setSaving(false); return; }
      const cant = Number(form.cantidad);

      const existe = items.find(i => i.catalogoId === form.catalogoId && i.embajadoraId === form.embajadoraId);
      if (existe) {
        await updateDoc(doc(db, 'stock', existe.id), {
          ingresos: (existe.ingresos || 0) + cant,
          stockDisponible: existe.stockDisponible + cant,
          updatedAt: serverTimestamp()
        });
        await addDoc(collection(db, 'movimientos'), {
          tipo: 'ingreso', stockId: existe.id,
          producto: existe.producto, aroma: existe.aroma,
          embajadoraId: existe.embajadoraId, embajadoraNombre: existe.embajadoraNombre,
          cantidad: cant, observacion: 'Asignación de stock por admin', fecha: serverTimestamp()
        });
      } else {
        const newRef = await addDoc(collection(db, 'stock'), {
          catalogoId: form.catalogoId,
          producto: selectedCat.producto, aroma: selectedCat.aroma, precio: selectedCat.precio,
          embajadoraId: form.embajadoraId, embajadoraNombre: emb.name,
          stockInicial: cant, ingresos: cant, egresos: 0,
          stockDisponible: cant, stockMinimo: Number(form.stockMinimo),
          createdAt: serverTimestamp()
        });
        await addDoc(collection(db, 'movimientos'), {
          tipo: 'ingreso', stockId: newRef.id,
          producto: selectedCat.producto, aroma: selectedCat.aroma,
          embajadoraId: form.embajadoraId, embajadoraNombre: emb.name,
          cantidad: cant, observacion: 'Asignación inicial de stock por admin', fecha: serverTimestamp()
        });
      }
      await load(); setShowModal(false); setForm(emptyForm);
    } catch (err) { setError(err.message); }
    setSaving(false);
  }

  async function handleIngreso(e) {
    e.preventDefault();
    if (!selectedItem) return;
    setSaving(true);
    try {
      const cant = Number(ingresoForm.cantidad);
      await updateDoc(doc(db, 'stock', selectedItem.id), {
        ingresos: (selectedItem.ingresos || 0) + cant,
        stockDisponible: selectedItem.stockDisponible + cant,
        updatedAt: serverTimestamp()
      });
      await addDoc(collection(db, 'movimientos'), {
        tipo: 'ingreso', stockId: selectedItem.id,
        producto: selectedItem.producto, aroma: selectedItem.aroma,
        embajadoraId: selectedItem.embajadoraId, embajadoraNombre: selectedItem.embajadoraNombre,
        cantidad: cant, observacion: ingresoForm.observacion || 'Ingreso manual', fecha: serverTimestamp()
      });
      await load(); setShowIngresoModal(false); setIngresoForm({ cantidad: 1, observacion: '' });
    } catch (err) { console.error(err); }
    setSaving(false);
  }

  function getAlertBadge(item) {
    if (item.stockDisponible === 0) return <span className="badge badge-red">Sin stock</span>;
    if (item.stockDisponible <= item.stockMinimo) return <span className="badge badge-yellow">Stock bajo</span>;
    return <span className="badge badge-green">OK</span>;
  }

  return (
    <div>
      {isAdmin && (
        <>
          <div className="stats-grid" style={{ marginBottom: 20 }}>
            <div className="stat-card">
              <div className="stat-label">Ítems totales</div>
              <div className="stat-value">{items.length}</div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Sin stock</div>
              <div className="stat-value" style={{ color: items.filter(i => i.stockDisponible === 0).length > 0 ? 'var(--alert-red)' : 'var(--forest)' }}>
                {items.filter(i => i.stockDisponible === 0).length}
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-label">Stock bajo</div>
              <div className="stat-value" style={{ color: items.filter(i => i.stockDisponible > 0 && i.stockDisponible <= i.stockMinimo).length > 0 ? 'var(--alert-yellow)' : 'var(--forest)' }}>
                {items.filter(i => i.stockDisponible > 0 && i.stockDisponible <= i.stockMinimo).length}
              </div>
            </div>
          </div>

          {Object.keys(stockTotal).length > 0 && (
            <div className="card" style={{ marginBottom: 20 }}>
              <div className="card-title">Stock total unificado</div>
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Producto</th><th>Aroma</th><th>Total unidades</th></tr></thead>
                  <tbody>
                    {Object.values(stockTotal).sort((a, b) => a.producto.localeCompare(b.producto)).map((s, i) => (
                      <tr key={i}>
                        <td style={{ fontWeight: 500 }}>{s.producto}</td>
                        <td style={{ color: 'var(--text-light)' }}>{s.aroma}</td>
                        <td><strong style={{ color: s.total === 0 ? 'var(--alert-red)' : 'var(--forest)' }}>{s.total}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}

      <div className="toolbar">
        <div className="toolbar-left">
          <input className="search-input" placeholder="Buscar..." value={search} onChange={e => setSearch(e.target.value)} />
          {isAdmin && (
            <select value={filterEmbajadora} onChange={e => setFilterEmbajadora(e.target.value)}>
              <option value="all">Todas las embajadoras</option>
              {embajadoras.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
            </select>
          )}
          <select value={filterAlerta} onChange={e => setFilterAlerta(e.target.value)}>
            <option value="all">Todos</option>
            <option value="urgente">Sin stock</option>
            <option value="bajo">Stock bajo</option>
            <option value="ok">OK</option>
          </select>
        </div>
        {isAdmin && (
          <button className="btn btn-primary" onClick={() => { setShowModal(true); setError(''); setForm(emptyForm); }}>
            + Asignar stock
          </button>
        )}
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-wrap">
          {loading ? <div className="spinner" /> : (
            <table>
              <thead>
                <tr>
                  <th>Producto</th><th>Aroma</th>
                  {isAdmin && <th>Embajadora</th>}
                  <th>Precio</th><th>Disponible</th><th>Ingresos</th><th>Egresos</th><th>Mínimo</th><th>Estado</th>
                  {isAdmin && <th>Acciones</th>}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={10} style={{ textAlign: 'center', color: 'var(--text-light)', padding: 40 }}>
                    {isAdmin ? 'Sin stock asignado' : 'Tu stock aparecerá acá cuando la administradora te asigne productos'}
                  </td></tr>
                ) : filtered.map(item => (
                  <tr key={item.id}>
                    <td style={{ fontWeight: 500 }}>{item.producto}</td>
                    <td style={{ color: 'var(--text-light)' }}>{item.aroma}</td>
                    {isAdmin && <td>{item.embajadoraNombre}</td>}
                    <td style={{ color: 'var(--forest)', fontWeight: 600 }}>
                      {item.precio ? `$${Number(item.precio).toLocaleString('es-AR', { maximumFractionDigits: 0 })}` : '—'}
                    </td>
                    <td style={{ fontWeight: 700, fontSize: 15 }}>{item.stockDisponible}</td>
                    <td style={{ color: 'var(--alert-green)' }}>+{item.ingresos || 0}</td>
                    <td style={{ color: 'var(--alert-red)' }}>-{item.egresos || 0}</td>
                    <td style={{ color: 'var(--text-light)' }}>{item.stockMinimo}</td>
                    <td>{getAlertBadge(item)}</td>
                    {isAdmin && (
                      <td>
                        <button className="btn btn-secondary btn-sm" onClick={() => { setSelectedItem(item); setShowIngresoModal(true); }}>
                          + Ingreso
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modal asignar stock */}
      {showModal && isAdmin && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">Asignar stock</div>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
            {catalogo.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon">◈</div>
                <p>El catálogo está vacío. Cargá productos en las pestañas Productos y Catálogo primero.</p>
              </div>
            ) : (
              <form className="modal-form" onSubmit={handleAddStock}>
                <div className="field-group">
                  <label>Embajadora</label>
                  <select value={form.embajadoraId} onChange={e => setForm(f => ({ ...f, embajadoraId: e.target.value }))} required>
                    <option value="">Seleccionar...</option>
                    {embajadoras.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                  </select>
                </div>
                <div className="field-group">
                  <label>Producto del catálogo</label>
                  <select value={form.catalogoId} onChange={e => setForm(f => ({ ...f, catalogoId: e.target.value }))} required>
                    <option value="">Seleccionar...</option>
                    {catalogo.map(c => (
                      <option key={c.id} value={c.id}>
                        {c.producto} · {c.aroma} — ${Number(c.precio).toLocaleString('es-AR', { maximumFractionDigits: 0 })}
                      </option>
                    ))}
                  </select>
                </div>
                {selectedCat && (
                  <div className="info-pill">
                    Precio: <strong>${Number(selectedCat.precio).toLocaleString('es-AR', { maximumFractionDigits: 0 })}</strong>
                    &nbsp;· Comisión: <strong>${(selectedCat.precio * 0.2).toLocaleString('es-AR', { maximumFractionDigits: 0 })}</strong>
                  </div>
                )}
                <div className="grid-2">
                  <div className="field-group">
                    <label>Cantidad a asignar</label>
                    <input type="number" min="1" value={form.cantidad} onChange={e => setForm(f => ({ ...f, cantidad: e.target.value }))} required />
                  </div>
                  <div className="field-group">
                    <label>Stock mínimo</label>
                    <input type="number" min="0" value={form.stockMinimo} onChange={e => setForm(f => ({ ...f, stockMinimo: e.target.value }))} required />
                  </div>
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn btn-ghost" onClick={() => setShowModal(false)}>Cancelar</button>
                  <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '...' : 'Asignar'}</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Modal ingreso adicional */}
      {showIngresoModal && selectedItem && isAdmin && (
        <div className="modal-overlay" onClick={() => setShowIngresoModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">Registrar ingreso</div>
              <button className="modal-close" onClick={() => setShowIngresoModal(false)}>✕</button>
            </div>
            <div style={{ marginBottom: 16, fontSize: 13, color: 'var(--text-light)' }}>
              <strong style={{ color: 'var(--text-dark)' }}>{selectedItem.producto} · {selectedItem.aroma}</strong>
              <span> · {selectedItem.embajadoraNombre}</span><br />
              Stock actual: <strong style={{ color: 'var(--forest)' }}>{selectedItem.stockDisponible}</strong>
            </div>
            <form className="modal-form" onSubmit={handleIngreso}>
              <div className="field-group">
                <label>Cantidad a ingresar</label>
                <input type="number" min="1" value={ingresoForm.cantidad} onChange={e => setIngresoForm(f => ({ ...f, cantidad: e.target.value }))} required />
              </div>
              <div className="field-group">
                <label>Observación (opcional)</label>
                <textarea rows={2} value={ingresoForm.observacion} onChange={e => setIngresoForm(f => ({ ...f, observacion: e.target.value }))} />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-ghost" onClick={() => setShowIngresoModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '...' : 'Registrar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ──────────────────────────────────────
export default function Stock() {
  const { userData } = useAuth();
  const isAdmin = userData?.role === 'admin';
  const [tab, setTab] = useState('stock');

  return (
    <div>
      <div className="page-header">
        <h1>Stock</h1>
        <p>{isAdmin ? 'Gestión de inventario, catálogo y productos' : 'Tu inventario asignado'}</p>
      </div>
      <div className="page-body">
        {isAdmin && (
          <div className="tabs">
            <button className={`tab${tab === 'productos' ? ' active' : ''}`} onClick={() => setTab('productos')}>
              Productos y Aromas
            </button>
            <button className={`tab${tab === 'catalogo' ? ' active' : ''}`} onClick={() => setTab('catalogo')}>
              Catálogo y Precios
            </button>
            <button className={`tab${tab === 'stock' ? ' active' : ''}`} onClick={() => setTab('stock')}>
              Stock por Embajadora
            </button>
          </div>
        )}
        {tab === 'productos' && isAdmin && <Productos />}
        {tab === 'catalogo' && isAdmin && <Catalogo />}
        {(tab === 'stock' || !isAdmin) && <StockEmbajadoras userData={userData} isAdmin={isAdmin} />}
      </div>
    </div>
  );
}